import ajax from '../../common/services/httpService'
const BASE_URL = 'sensor'

/**@typedef {{
 * site_id: Number;
 * room_id: Number;
 * deviceType: String;
 * company_id: Number;
 * desc: String;
 * device_code?: String;
 * }} Device*/

/**@typedef {{
 * company_id: number;
 * desc?:string;
 * device_code:string;
 * last_signal:string;
 * room_id:string | number;
 * sensor_code:string;
 * servikId?:number;
 * site_id:number | string;
 * type: string;
 * }} Sensor*/

async function getDeviceTypes() {
    const res = await ajax.get(`${BASE_URL}/types`)
    return res
}

/**@param {Device} device */
async function addSensor(device) {
    const res = await ajax.post(BASE_URL, device)
    return res
}

/**@param {Device} device */
async function updateSensor(device) {
    const res = await ajax.put(BASE_URL, device)
    return res
}

/**@param {String} device_code */
async function remove(device_code) {
    const res = await ajax.delete(BASE_URL, { device_code })
    return res
}

/**@param {number} roomId */
async function getSensorByRoomId(roomId) {
    /**@type {Sensor} */
    const sensor = await ajax.get(`${BASE_URL}/sensor/${roomId}`)
    return sensor
}

/**@param {string} deviceCode */
/**@param {{ silent?: boolean }} [options] */
async function getByDeviceCode(deviceCode, options = {}) {
    /**@type {Sensor} */
    const encoded = encodeURIComponent(deviceCode)
    const sensor = await ajax.get(`${BASE_URL}/${encoded}`, null, null, options)
    return sensor
}

async function getSitesSensorsStatus() {
    const tablet = await ajax.get(`${BASE_URL}/sitesDevices`)
    return tablet
}

async function getSensorErrors(deviceCode) {
    const errors = await ajax.get(`${BASE_URL}/errors/${deviceCode}`)
    return errors
}

async function getFaultyCounters() {
    const faultyCounters = await ajax.get(`${BASE_URL}/faultyCounters`)
    return faultyCounters
}

async function removeFaultyCounter(device_code) {
    const faultyCounter = await ajax.delete(`${BASE_URL}/faultyCounter`, { device_code })
    return faultyCounter
}

/**
 * Save a sensor maintenance note
 * @param {Object} noteData - The maintenance note data
 * @returns {Promise<any>} - Response data
 */
async function saveSensorNote(noteData) {
    try {
        const response = await ajax.post(`${BASE_URL}/notes`, noteData)
        return response
    } catch (error) {
        console.error('Error saving sensor note:', error)
        throw error
    }
}

/**
 * Get maintenance history for a specific sensor and type
 * @param {string} sensorCode - The sensor code
 * @param {string} maintenanceType - Optional maintenance type filter
 * @returns {Promise<any>} - Maintenance history data
 */
async function getMaintenanceHistory(sensorCode, maintenanceType = null) {
    try {
        let url = `${BASE_URL}/${sensorCode}/maintenance-history`
        if (maintenanceType) {
            url += `?type=${maintenanceType}`
        }
        
        const response = await ajax.get(url)
        return response
    } catch (error) {
        console.error('Error fetching maintenance history:', error)
        throw error
    }
}

/**
 * Get all maintenance notes for a sensor
 * @param {string} sensorCode - The sensor code
 * @returns {Promise<any>} - All maintenance notes data
 */
async function getAllMaintenanceNotes(sensorCode) {
    try {
        const response = await ajax.get(`${BASE_URL}/${sensorCode}/maintenance-notes`)
        return response
    } catch (error) {
        console.error('Error fetching all maintenance notes:', error)
        throw error
    }
}

/**
 * Update a maintenance note
 * @param {number} noteId - The note ID
 * @param {Object} updateData - Data to update
 * @returns {Promise<any>} - Update response
 */
async function updateSensorNote(noteId, updateData) {
    try {
        const response = await ajax.put(`${BASE_URL}/notes/${noteId}`, updateData)
        return response
    } catch (error) {
        console.error('Error updating sensor note:', error)
        throw error
    }
}

/**
 * Delete a maintenance note
 * @param {number} noteId - The note ID
 * @returns {Promise<any>} - Delete response
 */
async function deleteSensorNote(noteId) {
    try {
        const response = await ajax.delete(`${BASE_URL}/notes/${noteId}`)
        return response
    } catch (error) {
        console.error('Error deleting sensor note:', error)
        throw error
    }
}

export default {
    addSensor,
    updateSensor,
    remove,
    getByDeviceCode,
    getDeviceTypes,
    getSensorByRoomId,
    getSitesSensorsStatus,
    getSensorErrors,
    getFaultyCounters,
    removeFaultyCounter,
    saveSensorNote,
    getMaintenanceHistory,
    getAllMaintenanceNotes,
    updateSensorNote,
    deleteSensorNote
}